<div *ngIf="newHomePedirDelivery">
	<div *ngIf="item.type != 'general' || item.hasStock !== false || showStockPausedItems() || allRequiredExtrasOutOfStock"
		data-cy="menuItem" 
		class="product-card-new-design hover-anim" 
		[ngClass]="{'card-product__without-stock' : item.hasStock === false, 'product-card--disabled' : allRequiredExtrasOutOfStock, 'product-card--list': !isFeatured, 'product-card--no-description': !isFeatured && !item.description && !item.tag}"
		(click)="!allRequiredExtrasOutOfStock && goToItemPage(item)">
		<div class="card-container">
			<div class="info-container" [class.title-short]="isShortTitle()">
				<div class="tag-container" *ngIf="item.tag">
					<span class="product-tag">{{item.tag}}</span>
				</div>
				<h3 class="item-name">{{item.name}}</h3>
				<p class="unavailable-text" *ngIf="item.hasStock === false || allRequiredExtrasOutOfStock" data-cy="hasStock">
					Indisponível no momento
				</p>
				<div *ngIf="item.hasStock !== false && !allRequiredExtrasOutOfStock" class="text-block" [class.has-tag]="item.tag">
					<p *ngIf="isInstagramUA && item.description" class="item-description">
						{{descriptionText}}
					</p>
					<p *ngIf="!isInstagramUA && item.description"
					[innerHTML]="descriptionHtml"
					class="item-description">
					</p>
				</div>
				<div class="price-container">
					<div *ngIf="item.price > 0 && !item.fromPrice" class="price-content">
						<span class="current-price">{{item.price | multiCurrency}}</span>
						<span *ngIf="showOldPrice" class="old-price">{{item.oldPrice | multiCurrency}}</span>
					</div>
					<div *ngIf="item.fromPrice" class="price-content">
						<span class="from-text">{{'From_price' | translate}} </span>
						<span class="price-value">{{item.fromPrice | multiCurrency}}</span>
						<span *ngIf="showOldPrice" class="old-price">{{item.oldPrice | multiCurrency}}</span>
					</div>
				</div>
			</div>
			
			<div class="image-container" (click)="item.image && openViewer(item); $event.stopPropagation();">
				<mp-img *ngIf="item.image" class="item-image" imgURL="{{imgURL}}/products/{{item.image}}/thumb_{{item.image}}.jpg"></mp-img>
				<img *ngIf="!item.image && isFeatured" class="item-image" [src]="defaultImage" alt="{{item.name}}">
				<div *ngIf="!item.image && !isFeatured" class="image-placeholder" aria-hidden="true"></div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="!newHomePedirDelivery">
	<ion-card *ngIf="item.type != 'general' || item.hasStock !== false || showStockPausedItems() || allRequiredExtrasOutOfStock" data-cy="menuItem" class="product-card hover-anim" [ngClass]="{'card-product__without-stock' : item.hasStock === false, 'product-card--disabled' : allRequiredExtrasOutOfStock}" mode="md" (click)="!allRequiredExtrasOutOfStock && goToItemPage(item)">
		<ion-grid>
			<ion-row>
				<ion-col size="3" class="p-0 centralize" *ngIf="item.image">
					<mp-img class="item-image" imgURL="{{imgURL}}/products/{{item.image}}/thumb_{{item.image}}.jpg" (click)="openViewer(item); $event.stopPropagation();"></mp-img>
				</ion-col>
				<ion-col size="{{item.image ? '9' : '12'}}" class="p-0">
					<ion-card-header class="pb-0">
						<ion-card-title class="text-wrap item-name">{{item.name}}</ion-card-title>
						<ion-label class="text-wrap text-right" *ngIf="item.hasStock === false || allRequiredExtrasOutOfStock" data-cy="hasStock">
							Indisponível no momento
						</ion-label>
					</ion-card-header>
					<ion-card-content>
						<ion-label *ngIf="isInstagramUA" class="text-wrap">{{descriptionText}}</ion-label>
						<!-- innerHTML num span interno: bindar direto no ion-label (host Stencil) faz o
						     polyfill de slot do Ionic 8 engolir o conteúdo (vira comentário s-nt) -->
						<ion-label *ngIf="!isInstagramUA" class="text-wrap"><span [innerHTML]="descriptionHtml"></span></ion-label>
						<br>
						<ion-label class="product-card-label" *ngIf="item.price > 0 && !item.fromPrice">
							{{item.fromPrice}}
							<b *ngIf="showOldPrice"><del style="color:grey;">{{item.oldPrice | multiCurrency}}</del>&nbsp;</b>
							<b>{{item.price | multiCurrency}}</b>
						</ion-label>
						<ion-label class="product-card-label" *ngIf="item.fromPrice">
							<b>{{'From_price' | translate}} </b>
							<del style="color:grey;" *ngIf="showOldPrice">{{item.oldPrice | multiCurrency}} </del>
							<b>{{item.fromPrice | multiCurrency}}</b>
						</ion-label>
					</ion-card-content>
				</ion-col>
			</ion-row>
			<ion-row *ngIf="item.tag">
				<ion-col size="12" class="text-center">
					<ion-text class="product-tag">{{item.tag}}</ion-text>
				</ion-col>
			</ion-row>
		</ion-grid>
	</ion-card>
</div>